import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Dropdown, Form, InputGroup, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { CAT, MAS, REP_BLOCK, REP_SEC, SUB } from "../../../../../shared/Data/typeDirs";
import { useSource } from "../../../sourceContext";

import "../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/categorySelector.css"
import { CategoryMenu } from "../categorySelector/categoryMenu";
import { ReportV2 } from "../../../../../shared/Objects/newReportObjects/report_v2";
import { useControlHeaderContext } from "../../../controlWrapperContext";

export function ExportCategories({
  name,
  idx
}) {
  const [requestLink, setRequestLink] = useState(false)
  
  const controls = useControl()
  const { [idx - 1]: previousBlock, [idx]: block } = controls
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(()=>( allReadOnly || ( lockMap && lockMap[block._id] )), [allReadOnly, lockMap, block._id])
  const [menuState, setMenuState] = useState({ [REP_SEC]: block[REP_SEC], [MAS]: block[MAS], [CAT]: block[CAT], [SUB]: block[SUB] })
  useEffect(
    () => setMenuState({ [REP_SEC]: block[REP_SEC], [MAS]: block[MAS], [CAT]: block[CAT], [SUB]: block[SUB] }),
    [block])

  const source = useSource()
  const controlReducer = useControlReducer()


  function locateSourceEntry(_id, src) {
    return src.find(itm => itm._id === _id)
  }

  let blockNameTimeoutId = useRef()

  const blockNameChanged = useCallback(({ target: { value } }) => {
    clearTimeout(blockNameTimeoutId.current)
    blockNameTimeoutId.current = setTimeout(() => {

      controlReducer({ idx, type: 'changed', name: 'blockName', value })
    }, 500)
  }, [controlReducer, idx])

  const onApply = useCallback(() => {

    let changedData = getSubcategoryChangedData(menuState[SUB], source, menuState[REP_SEC])
    console.log('CategorySelector | onApply: subcategory changed to', changedData)
    controlReducer({type:'basic_changed', idx, name, payload:changedData})
    setTimeout(()=>controlReducer({type:'sort_blocks', idx, name, sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source)}), 100)

    setTimeout(() => setRequestLink(block._id), 100)
    document.body.click()
  }, [controlReducer, controls, source, idx, block, menuState, name])

  const categorySelectorComponent = useMemo(() => {
    let isFirstOfSection = (previousBlock && previousBlock.type !== REP_BLOCK) ||
      (previousBlock && previousBlock[REP_SEC] !== block[REP_SEC]),
      isFirstOfCategory = (previousBlock && previousBlock.type !== REP_BLOCK) ||
        (previousBlock && previousBlock[REP_SEC] !== block[REP_SEC]) ||
        (previousBlock && previousBlock[CAT] !== block[CAT]),
      category = source[CAT] && locateSourceEntry(block[CAT], source[CAT]),
      subcategory = source[SUB] && locateSourceEntry(block[SUB], source[SUB]),
      reportSection = source[REP_SEC] && locateSourceEntry(block[REP_SEC], source[REP_SEC])

    return (
      <div key={`${block._id}${block.blockName}`} className="g-0 category-selector-container">
        {
          isFirstOfSection ? (
            <Row className="report-section-header">
              <h1>{reportSection.getDisplayText() || 'Section 1: Site'}</h1>
            </Row>
          ) : []
        }
        {
          isFirstOfCategory ? (
            <Row className="report-category-header">
              <h2 className="report-category-text">
                {category && category.content}
              </h2>
            </Row>
          ) : []
        }
        <Row className="report-blockName-container">
          <InputGroup>
            <span className="report-blockName-subcategory-number">
              {`${subcategory.fullNumber.slice(subcategory.fullNumber.indexOf('.') + 1)}`} &nbsp; — &nbsp;
            </span>
            {readOnly ? (
              <div>
                {block.blockName}
              </div>
            ) : (
              <Form.Control
                type="text"
                defaultValue={block.blockName}
                onChange={blockNameChanged} />
            )}
            {readOnly ? [] : (
              <span>
                <OverlayTrigger
                  rootClose
                  trigger={['click']}
                  placement="right"
                  overlay={(props) => (
                    <Popover  {...props} className="report-category-menu-popover">
                      <Popover.Title>Select Section and Categorization for Report Block</Popover.Title>
                      <Popover.Content>
                        <div className="report-category-menu-overlay-container">
                          <CategoryMenu
                            source={source}
                            menuState={menuState}
                            onClick={(type, id) => setMenuState({ ...menuState, [type]: id })}
                          />
                        </div>

                      </Popover.Content>
                      <Popover.Title>
                        <Button variant="outline-activated" onClick={onApply} >Apply</Button>
                      </Popover.Title>
                    </Popover>
                  )}>
                  <Dropdown.Toggle variant="info"></Dropdown.Toggle>
                </OverlayTrigger>
              </span>
            )}
          </InputGroup>
        </Row>
      </div>
    )
  }, [
    readOnly,
    block,
    previousBlock,
    menuState,
    source,
    onApply,
    blockNameChanged,

  ])

  function scrollToThing(blockId) {
    console.log('scrolling to block', blockId)
    document.getElementById(blockId).scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    if (requestLink) {
      scrollToThing(requestLink)
      setTimeout(() => setRequestLink(false))
    }
  }, [requestLink])


  return categorySelectorComponent
}


function getSubcategoryChangedData(subcategoryid, source, reportSection) {
  let subcategory = source[SUB].find(sub => sub._id === subcategoryid)
  let category = source[CAT].find(cat => cat._id === subcategory._categories)
  return {
    [REP_SEC]: reportSection,
    [SUB]: subcategory._id,
    [CAT]: category._id,
    [MAS]: category._mastercategories,
    blockName: subcategory.content
  }
}